import { Pipe, PipeTransform } from "@angular/core";
import { Translation } from "../models/entities/translation";

@Pipe({ name: "distinct" })
export class DistinctPipe implements PipeTransform {
  transform(value: { Id: number }[]): any[] {
    const tmp: { Id: number }[] = [];
    if (value == null || value.length == 0) {
      return [];
    }
    value.forEach((e) => {
      if (tmp.filter((t) => t.Id == e.Id).length == 0) {
        tmp.push(e);
      }
    });
    return tmp;
  }
}
